import App from '@/app'

const counterUpObserver = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.animate()

			counterUpObserver.unobserve(entry.target)
		}
	})
}, {
	root: null,
	threshold: [ .1,.2,.3,.4,.5,.6,.7,.8,.9,1 ]
})

App.directive('counterup', (el, binding) => {
	const from     = binding.value.from     || 0
	const to       = binding.value.to       || 1000
	const preffix  = binding.value.preffix  || ''
	const suffix   = binding.value.suffix   || ''
	const duration = binding.value.duration || 2000

	const animate = () => {
		let startTime   = null
		let currentTime = Date.now()
		let connection;

		const step = (currentTime) => {

			// Checking startTime
			if (startTime === null) startTime = currentTime

			// Calculate the progress
			const progress = Math.min(
				( currentTime - startTime) / duration,
				1
			)

			const currentValue = Math.floor(
				progress * (to - from) + from
			)

			el.innerHTML = `${preffix}${currentValue}${suffix}`

			if (progress >= 1) return cancelAnimationFrame(connection)

			connection = requestAnimationFrame(step)
		}

		connection = requestAnimationFrame(step)
	}

	el.animate = animate

	counterUpObserver.observe(el)
})
